import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "../components/brand/Logo";
import { useSite } from "../lib/site";

const PAGES = {
  terminos: ["Términos y condiciones del servicio", "terminos"],
  privacidad: ["Aviso de privacidad", "privacidad"],
  "quienes-somos": ["Quiénes somos", "aviso_legal"],
  "aviso-legal": ["Quiénes somos", "aviso_legal"],
};

export default function Legal() {
  const { slug } = useParams();
  const { content } = useSite();
  const page = PAGES[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <div className="min-h-screen bg-paper" data-testid="legal-page">
      <header className="bg-ink">
        <div className="container-x flex h-[72px] items-center justify-between">
          <Link to="/" data-testid="legal-home-link"><Logo tone="light" className="h-8" /></Link>
          <Link to="/" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.12em] text-white/85 hover:text-leaf" data-testid="legal-back-link">
            <ArrowLeft className="h-4 w-4" /> Volver
          </Link>
        </div>
      </header>
      <main className="container-x max-w-3xl py-20">
        {page ? (
          <>
            <h1 className="font-display text-4xl font-semibold tracking-tight sm:text-5xl" data-testid="legal-title">{page[0]}</h1>
            <p className="mt-3 text-sm text-ink/70" data-testid="legal-company">{content.legal.company_name} · {content.legal.domicilio}</p>
            <div className="mt-10 whitespace-pre-line text-base leading-relaxed text-ink/85" data-testid="legal-body">{content.legal[page[1]]}</div>
          </>
        ) : (
          <h1 className="font-display text-4xl font-semibold">Página no encontrada</h1>
        )}
      </main>
    </div>
  );
}
